import { AutoConfiguratorState } from '@snap-types/models/auto-configurator/state';

import { createLineItemFields } from './fields/line-item';
import { createQuantityBreakFields } from './fields/quantity-break';

export const initialState: AutoConfiguratorState = {
  siteCode: null,
  quoteContext: {
    snapQuoteUuid: null,
    alphaQuoteUuid: null,
  },
  pendingRecalculationCount: 0,
  pendingCalculationRequestIdByLineItemUuid: {},
  calculationErrorsByLineItemUuid: {},
  lastSaveDateTime: null,

  lastImportResultsBySiteCode: {},
  lastImportUuidsBySiteCode: {},

  lineItemUuids: [],
  lineItems: {},
  quantityBreaks: {},

  fields: {
    lineItem: createLineItemFields(),
    quantityBreak: createQuantityBreakFields(),
  },
  staticData: null,
};
